import styles from "./ExpiredHeaderLayout.module.scss";
// import { Outlet } from "react-router-dom";
import Button from "../../button/Button";
import Modal from "../../modal/modal";
import GetPremiumModal from "../../modals/GetPremiumModal/GetPremiumModal";
import { useState } from "react";
import OrderSummaryModal from "../../modals/OrderSummaryModal/OrderSummaryModal";
import { useTranslation } from "react-i18next";

const ExpiredHeaderLayout = () => {
  const [isModalUpdateVisible, setIsModalUpdateVisible] = useState(false);
  const [isModalOrderVisible, setIsModalOrderVisible] = useState(false);
  const { t } = useTranslation();
  return (
    <>
      <div className={styles.root}>
        <div className={styles.content}>
        <div>
          <p className={styles.root_offer}>{t("Special offer")}</p>
          <p className={styles.root_save}>{t("Get Fortect today and Save 50%")}</p>
        </div>
        <Button
          classNames={styles.root_button}
          onClick={() => window.open("https://secure.fortect.com/", "_blank")}
          type="expired"
          text={t("Upgrade now")}
        />
        </div>
        <Modal isOpen={isModalUpdateVisible} setIsVisible={() => setIsModalUpdateVisible(false)}>
          <GetPremiumModal
            setIsModalUpdateVisible={setIsModalUpdateVisible}
            setIsModalOrderVisible={setIsModalOrderVisible}
          />
        </Modal>

        <Modal isOpen={isModalOrderVisible} setIsVisible={() => setIsModalOrderVisible(false)}>
          <OrderSummaryModal />
        </Modal>
      </div>

      {/* <Outlet /> */}
    </>
  );
};

export default ExpiredHeaderLayout;
